import { render } from "./CustomerDocumentCard.vue?vue&type=template&id=7b31b6fc"
import script from "./CustomerDocumentCard.vue?vue&type=script&lang=js"
export * from "./CustomerDocumentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__